import { isAuthenticatedSignal } from '../../state/auth.store';
import { AuthModal } from '../auth/AuthModal';
import { GeminiKeyModal } from '../modals/GeminiKeyModal';
import { ToastContainer } from '../common/ToastContainer';

interface AppShellProps {
  children?: any;
}

export function AppShell({ children }: AppShellProps) {
  const isAuthenticated = isAuthenticatedSignal.value;

  if (!isAuthenticated) {
    return (
      <div class="app-shell-auth-container">
        <AuthModal />
        <ToastContainer />
      </div>
    );
  }

  return (
    <div class="app-shell">
      {children}
      <GeminiKeyModal />
      <ToastContainer />
    </div>
  );
}
